import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IAddProjectSchema, IProjectState } from './types';

const initialState: IProjectState = {
  addProject: {},
  projects: {},
  updateProjectStatus: {},
  projectDetails: {},
  updateProject: {},
};

const slice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    getProjects(state, action: PayloadAction<string | undefined>) {
      state.projects.status = RequestStatus.RUNNING;
    },
    getProjectsSuccess(state, action: PayloadAction<IProjectState['projects']['data']>) {
      state.projects.status = RequestStatus.SUCCESS;
      state.projects.data = action.payload;
    },
    getProjectsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.projects.status = RequestStatus.ERROR;
      state.projects.error = action.payload;
    },
    //
    addProject(state, action: PayloadAction<IAddProjectSchema>) {
      state.addProject.status = RequestStatus.RUNNING;
    },
    addProjectSuccess(state, action) {
      state.addProject.status = RequestStatus.SUCCESS;
      state.addProject.data = action.payload;
    },
    addProjectFailed(state, action: PayloadAction<IRequestFailed>) {
      state.addProject.status = RequestStatus.ERROR;
      state.addProject.error = action.payload;
    },
    //
    updateProjectStatus(state, action: PayloadAction<IAddProjectSchema>) {
      state.updateProjectStatus.status = RequestStatus.RUNNING;
    },
    updateProjectStatusSuccess(state, action: PayloadAction<IAddProjectSchema>) {
      state.updateProjectStatus.status = RequestStatus.SUCCESS;
      state.updateProjectStatus.data = action.payload;
    },
    updateProjectStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateProjectStatus.status = RequestStatus.ERROR;
      state.updateProjectStatus.error = action.payload;
    },
    //
    getProjectDetails(state, action: PayloadAction<IAddProjectSchema>) {
      state.projectDetails.status = RequestStatus.RUNNING;
    },
    getProjectDetailsSuccess(
      state,
      action: PayloadAction<IProjectState['projectDetails']['data']>
    ) {
      state.projectDetails.status = RequestStatus.SUCCESS;
      state.projectDetails.data = action.payload;
    },
    getProjectDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.projectDetails.status = RequestStatus.ERROR;
      state.projectDetails.error = action.payload;
    },
    //
    updateProject(state, action: PayloadAction<any>) {
      state.updateProject.status = RequestStatus.RUNNING;
    },
    updateProjectSuccess(state, action: PayloadAction<IAddProjectSchema>) {
      state.updateProject.status = RequestStatus.SUCCESS;
      state.updateProject.data = action.payload;
    },
    updateProjectFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateProject.status = RequestStatus.ERROR;
      state.updateProject.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  addProject,
  addProjectSuccess,
  addProjectFailed,
  getProjects,
  getProjectsFailed,
  getProjectsSuccess,
  updateProjectStatus,
  updateProjectStatusFailed,
  updateProjectStatusSuccess,
  getProjectDetails,
  getProjectDetailsFailed,
  getProjectDetailsSuccess,
  updateProject,
  updateProjectFailed,
  updateProjectSuccess,
} = slice.actions;
